import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMagicWand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMagicWand"><Path d="M10.64 0.442383L11.1494 7.03753L5.51443 10.502L10.8052 11.7803L2.58594 19.9996L4.00015 21.4138L12.2194 13.1945L13.4978 18.4853L16.9622 12.8503L23.5573 13.3597L19.2687 8.3235L21.7912 2.20855L15.6762 4.731L10.64 0.442383Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMagicWand;
